import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import useRedirect from 'src/hooks/useRedirect';

const InvoiceNumberCell = (props: GridCellProps) => {
  const field = props.field || '';
  const data = props.dataItem[field];
  const { getUrl, redirect } = useRedirect();
  const className = props.dataItem.hasCompanyAccess ? 'cursor-pointer text-link underline' : '';

  const handleClick = useCallback(() => {
    redirect(
      getUrl('invoiceDetails')(String(props.dataItem.receiptId), String(props.dataItem.poId))
    );
  }, [getUrl, props.dataItem.poId, props.dataItem.receiptId, redirect]);

  return (
    <GridCellBase {...props} title={data} rowSelectionEnabled={true}>
      <button
        className={className}
        onClick={handleClick}
        disabled={!props.dataItem.hasCompanyAccess}
      >
        {data ? data : 'Unassigned'}
      </button>
    </GridCellBase>
  );
};

export default InvoiceNumberCell;
